<script setup lang="ts">
  import { computed } from 'vue';
  import { useShared } from '@othercommerce/foundation';
  import type { ListOfferQuotationResource } from '@storefront/resources';

  interface Props {
    offer: any,
    quotation: ListOfferQuotationResource,
  }

  const props = defineProps<Props>();
  const shared = useShared();

  const total = computed(() => {
    if (shared.value.includeVat) {
      return props.quotation.totalGross;
    } else {
      return props.quotation.totalNet;
    }
  });
</script>
<template>
  <RouterLink class="quotation" :href="$route('web.account.offers.quotations.show', { offer: offer.id, quotation: quotation.id })">
    <div class="quotation__header">
      <div class="quotation__title">
        {{ $t('SHOP.OFFER.HEADER.QUOTATION_NUMBER', { number: quotation.number }) }}
      </div>
      <div class="quotation__date">
        {{ $t('SHOP.OFFER.LABEL.QUOTATION_LAST_MODIFICATION') }}
        <SfDateTime time :value="quotation.updatedAt" />
      </div>
    </div>
    <div class="quotation__content">
      <SfOrderStatus :status="quotation.status" />
      <div class="quotation__total">
        <SfMoney :value="total" :decimals="quotation.currency.decimals" :code="quotation.currency.code" />
      </div>
    </div>
  </RouterLink>
</template>
<style scoped lang="scss">
  .quotation {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 0.5rem;
    border-radius: var(--border-radius);
    background-color: var(--secondary-background);
    transition-property: background-color;
    transition-timing-function: ease-in-out;
    transition-duration: 200ms;

    &:hover {
      //background-color: var(--secondary-background-hover);
    }

    &__title {
      font-weight: var(--font-weight-bold);
    }

    &__date {
      color: var(--secondary-color);
      font-size: 0.625rem;
    }

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__total {
      font-weight: var(--font-weight-bold);
    }
  }
</style>
